module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_DASHBOARD_E_ANALYTICS.5a10b56c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dashboardAnalytics/PC_Carrosel_DASHBOARD_E_ANALYTICS.png
// module id = 189
// module chunks = 0